import { lazy } from 'react'
import { useAppShellLayoutContext } from '@/components/AppShell/AppShellLayoutContext'

const MainContentLayout = lazy(() => import('@/components/MainContentLayout'))
const AppGenPage = lazy(() => import('@/features/appgen/AppGenPage.jsx'))

export function useShellLayout() {
  return /** @type {ReturnType<import('@/components/AppShell/useAppShellLayout').useAppShellLayout>} */ (
    useAppShellLayoutContext()
  )
}

export function HomeMainLayoutRoute() {
  const { mainLayoutProps } = useShellLayout()
  return <MainContentLayout {...mainLayoutProps} />
}

export function AppGenRoute() {
  return <AppGenPage />
}
